import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';

const Contact = () => {
  const { t } = useLanguage();

  const contactInfo = {
    phone: '+380 95 045 81 21',
    email: 'advocategubareva@gmail.com',
    address: '63B Zmiivska Street, Bezliudivka, Kharkiv Region, Ukraine, 62489'
  };

  return (
    <section id="contact" className="section-padding contact-section">
      <div className="container">
        <h2 className="heading-1 section-title">{t.contact.title}</h2>
        
        <div className="grid-two-column">
          <div className="contact-info">
            <div className="contact-item">
              <Phone size={24} strokeWidth={1} />
              <div>
                <h3 className="body-large contact-label">{t.contact.phone}</h3>
                <a href={`tel:${contactInfo.phone}`} className="contact-value">{contactInfo.phone}</a>
              </div>
            </div>
            
            <div className="contact-item">
              <Mail size={24} strokeWidth={1} />
              <div>
                <h3 className="body-large contact-label">{t.contact.email}</h3>
                <a href={`mailto:${contactInfo.email}`} className="contact-value">{contactInfo.email}</a>
              </div>
            </div>
            
            <div className="contact-item">
              <MapPin size={24} strokeWidth={1} />
              <div>
                <h3 className="body-large contact-label">{t.contact.address}</h3>
                <p className="contact-value">{t.contact.addressValue}</p>
              </div>
            </div>

            <div className="contact-actions">
              <a href={`tel:${contactInfo.phone}`} className="btn-primary">
                {t.contact.callButton}
                <ArrowRight size={16} />
              </a>
              <a href={`mailto:${contactInfo.email}`} className="btn-secondary">
                {t.contact.emailButton}
              </a>
            </div>
          </div>
          
          <div className="contact-map">
            <iframe
              width="100%"
              height="400"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen=""
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d642.8038192039415!2d36.2967928!3d49.8759837!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x41277359c5a0c56f%3A0xec69acdc84e2a5ec!2z0JDQtNCy0L7QutCw0YIg0JPRg9Cx0LDRgNGU0LLQsCDQm9GW0LvRltGPINCQ0L3QsNGC0L7Qu9GW0ZfQstC90LA!5e0!3m2!1sru!2sua!4v1761686136056!5m2!1sru!2sua"
              title="Office Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;